import React, { useEffect, useState } from "react";

import Form from "@Components/Form";
import { ROLES_URL, URLS, NEW_USER_URL } from "configs/constants";
import { fetchDataFromApi } from "utils";

const initialValues = {
  employee_id: "",
};

const ApprovedAndRejectedUsersEditForm = () => {
  const [roles, setRoles] = useState([]);

  useEffect(() => {
    fetchDataFromApi(ROLES_URL, setRoles, true);
  }, []);

  useEffect(() => {
    const workerRole = roles.find((role) => role.name === "Worker");
    if (roles.includes(workerRole)) {
      setRoles(roles.filter((item) => item.name !== "Worker"));
    }
  }, [roles]);

  const formFields = [
    { type: "title", title: "Personal Details" },
    {
      type: "renderonly",
      name: "employee_id",
      key: "employee_id",
      label: "Employee ID",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "name",
      key: "name",
      label: "Employee Name",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "nationality",
      key: "nationality",
      label: "Nationality",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "worker_type",
      key: "worker_type",
      label: "Worker Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_type_name",
      key: "id_type_name",
      label: "ID Type",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "id_number",
      key: "id_number",
      label: "ID Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "mobile_number",
      key: "mobile_number",
      label: "Mobile Number",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "role_name",
      key: "role_name",
      label: "Role",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "status",
      key: "status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "title", title: "Employment Details" },
    {
      type: "renderonly",
      name: "worker_group_name",
      key: "worker_group_name",
      label: "Worker Group",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "company_name",
      key: "company_name",
      label: "Company",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "zone_name",
      key: "zone_name",
      label: "Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "region_name",
      key: "region_name",
      label: "Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "estate_name",
      key: "estate_name",
      label: "Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "division_name",
      key: "division_name",
      label: "Division",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "block_name",
      key: "block_name",
      label: "Block",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    { type: "title", title: "Allowable Estate Details" },

    {
      type: "renderonly",
      name: "allowables.All_Estates",
      key: "allowables.All_Estates",
      valueType: "boolean",
      noValue: "No",
      yesValue: "Yes",
   
      label: "All Estates",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "allowables.Zones",
      key: "allowables.Zones",
      label: "Allowable Zone",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "allowables.Regions",
      key: "allowables.Regions",
      label: "Allowable Region",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "allowables.Estates",
      key: "allowables.Estates",
      label: "Allowable Estate",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    

    { type: "title", title: "Audit Details" },
    {
      type: "renderonly",
      name: "created_at_datetime",
      key: "created_at_datetime",
      label: "Created Date and Time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "created_by",
      key: "created_by",
      label: "Created By",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "approval_status",
      key: "approval_status",
      label: "Status",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "approved_date",
      key: "approved_rejected_date",
      label: "Approved/Rejected Date & Time",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "approved_rejected_by",
      key: "approved_rejected_by",
      label: "Approved/Rejected By",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },
    {
      type: "renderonly",
      name: "remarks",
      key: "remarks",
      label: "Remarks",
      gridSize: { xs: 12, sm: 6, md: 4, lg: 3 },
    },

    // FIXME: Uncomment to add allowables
    // {
    //   type: "tabbeddisplay",
    //   label: "Allowables",
    //   gridSize: { xs: 12, sm: 12, md: 12, lg: 12 },
    //   valueForTabsKey: "allowables",
    //   renderKey: "bo_access",
    //   renderValue: true,
    // },
  ];

  const formButtons = ["cancel"];

  return (
    <Form
      initialValues={initialValues}
      submitUrl={NEW_USER_URL}
      listRoute={URLS.NON_PENDING_USERS_LIST}
      formFields={formFields}
      formButtons={formButtons}
      formTitle="Approved/Rejected User"
      noTypography
    />
  );
};

export default ApprovedAndRejectedUsersEditForm;
